export const CREATE_USER_HANDLE_CHARGEBACKS = 'CREATE_USER_HANDLE_CHARGEBACKS'
export const SET_USER_HANDLE_CHARGEBACKS_PROCESSING = 'SET_USER_HANDLE_CHARGEBACKS_PROCESSING'
export const SET_USER_HANDLE_CHARGEBACKS_PROGRESS = 'SET_USER_HANDLE_CHARGEBACKS_PROGRESS'
export const SET_USER_HANDLE_CHARGEBACKS_DATA = 'SET_USER_HANDLE_CHARGEBACKS_DATA'
export const SET_USER_HANDLE_CHARGEBACKS_ERROR = 'SET_USER_HANDLE_CHARGEBACKS_ERROR'
export const CREATE_USER_CANCEL_SUBSCRIPTIONS_IN_BATCH = 'CREATE_USER_CANCEL_SUBSCRIPTIONS_IN_BATCH'
export const SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROCESSING = 'SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROCESSING'
export const SET_SUBSCRIPTION_CANCELS_IN_BATCH_DATA = 'SET_SUBSCRIPTION_CANCELS_IN_BATCH_DATA'
export const SET_SUBSCRIPTION_CANCELS_IN_BATCH_ERROR = 'SET_SUBSCRIPTION_CANCELS_IN_BATCH_ERROR'
export const SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROGRESS = 'SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROGRESS'
export const CREATE_TURN_ON_AUTO_PAY_IN_BATCH = 'CREATE_TURN_ON_AUTO_PAY_IN_BATCH'
export const SET_TURN_ON_AUTO_PAY_IN_BATCH_PROCESSING = 'SET_TURN_ON_AUTO_PAY_IN_BATCH_PROCESSING'
export const SET_TURN_ON_AUTO_PAY_IN_BATCH_DATA = 'SET_TURN_ON_AUTO_PAY_IN_BATCH_DATA'
export const SET_TURN_ON_AUTO_PAY_IN_BATCH_ERROR = 'SET_TURN_ON_AUTO_PAY_IN_BATCH_ERROR'
export const SET_TURN_ON_AUTO_PAY_IN_BATCH_PROGRESS = 'SET_TURN_ON_AUTO_PAY_IN_BATCH_PROGRESS'
export const CREATE_USER_HANDLE_INVOICES_POST = 'CREATE_USER_HANDLE_INVOICES_POST'
export const SET_USER_HANDLE_INVOICES_POST_PROCESSING = 'SET_USER_HANDLE_INVOICES_POST_PROCESSING'
export const SET_USER_HANDLE_INVOICES_POST_PROGRESS = 'SET_USER_HANDLE_INVOICES_POST_PROGRESS'
export const SET_USER_HANDLE_INVOICES_POST_DATA = 'SET_USER_HANDLE_INVOICES_POST_DATA'
export const SET_USER_HANDLE_INVOICES_POST_ERROR = 'SET_USER_HANDLE_INVOICES_POST_ERROR'

export function createHandleChargebacks ({ paymentNumbers }) {
  return {
    type: CREATE_USER_HANDLE_CHARGEBACKS,
    payload: { paymentNumbers },
  }
}

export function setUserHandleChargebacksProgress ({ storeKey, progress, processing = true }) {
  return {
    type: SET_USER_HANDLE_CHARGEBACKS_PROGRESS,
    payload: { storeKey, progress, processing },
  }
}

export function setUserHandleChargebacksProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_HANDLE_CHARGEBACKS_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserHandleChargebacksData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_HANDLE_CHARGEBACKS_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserHandleChargebacksError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_HANDLE_CHARGEBACKS_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createCancelSubscriptionsInBatch ({ cancels }) {
  return {
    type: CREATE_USER_CANCEL_SUBSCRIPTIONS_IN_BATCH,
    payload: { cancels },
  }
}

export function setSubscriptionCancelsInBatchProgress ({ storeKey, progress, processing = true }) {
  return {
    type: SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROGRESS,
    payload: { storeKey, progress, processing },
  }
}

export function setSubscriptionCancelsInBatchProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setSubscriptionCancelsInBatchData ({ storeKey, data, processing = false }) {
  return {
    type: SET_SUBSCRIPTION_CANCELS_IN_BATCH_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setSubscriptionCancelsInBatchError ({ storeKey, error, processing = false }) {
  return {
    type: SET_SUBSCRIPTION_CANCELS_IN_BATCH_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createTurnOnAutoPayInBatch ({ accounts }) {
  return {
    type: CREATE_TURN_ON_AUTO_PAY_IN_BATCH,
    payload: { accounts },
  }
}

export function setTurnOnAutoPayInBatchProgress ({ storeKey, progress, processing = true }) {
  return {
    type: SET_TURN_ON_AUTO_PAY_IN_BATCH_PROGRESS,
    payload: { storeKey, progress, processing },
  }
}

export function setTurnOnAutoPayInBatchProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_TURN_ON_AUTO_PAY_IN_BATCH_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setTurnOnAutoPayInBatchData ({ storeKey, data, processing = false }) {
  return {
    type: SET_TURN_ON_AUTO_PAY_IN_BATCH_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setTurnOnAutoPayInBatchError ({ storeKey, error, processing = false }) {
  return {
    type: SET_TURN_ON_AUTO_PAY_IN_BATCH_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createHandleInvoicesPost ({ invoiceIds }) {
  return {
    type: CREATE_USER_HANDLE_INVOICES_POST,
    payload: { invoiceIds },
  }
}

export function setUserHandleInvoicesPostProgress ({ storeKey, progress, processing = true }) {
  return {
    type: SET_USER_HANDLE_INVOICES_POST_PROGRESS,
    payload: { storeKey, progress, processing },
  }
}

export function setUserHandleInvoicesPostProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_HANDLE_INVOICES_POST_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserHandleInvoicesPostData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_HANDLE_INVOICES_POST_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserHandleInvoicesPostError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_HANDLE_INVOICES_POST_ERROR,
    payload: { storeKey, error, processing },
  }
}
